import FinancialResume from './FinancialResume';

export default FinancialResume;
